var name = "UNT-01_1b2p_01s";
var uuid = "1f176ba0-0590-5c63-a840-6252897f79ba";
var pos = [
	0,
	0,
	0
];
var rot = [
	0,
	0,
	0
];
var size = [
	7.6,
	3.035,
	9.1875
];
var anchor = [
	0.5,
	0,
	1
];
var color = "#cccccc";
var alpha = 1;
var rg = true;
var type = "Apartment";
var children = [
	{
		name: "balcony",
		uuid: "1b693765-ba23-504f-88a5-d6710f800523",
		pos: [
			0.1625,
			0.145,
			-9.1875
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			3.5,
			0.16,
			2
		],
		anchor: [
			0,
			0,
			0
		],
		color: "#cccccc",
		alpha: 1,
		rg: true,
		type: "Balcony",
		children: [
			{
				name: "floor",
				uuid: "8ff883d4-6535-50a5-acf9-acdc84bd4f69",
				pos: [
					1.75,
					0.08,
					1
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.5,
					0.16,
					2
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "BFA|01|",
				type: "Floor"
			}
		]
	},
	{
		name: "Bedroom Double",
		uuid: "181b5500-4e7a-5420-8355-4aaff6edd0ae",
		pos: [
			-1.9125,
			0.305,
			-5.2138
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			3.5,
			2.4384,
			3.6475
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#a7dbd8",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "BedroomDouble"
		}
	},
	{
		name: "Kitchen / Living / Dining",
		uuid: "bc5c42d8-d385-5080-b92b-e254cd638a5f",
		pos: [
			1.9125,
			0.305,
			-3.5875
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			3.5,
			2.4384,
			6.9
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#00a0b0",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "KitchenLivingDining",
			polygon: [
				[
					3.6625,
					0.305,
					-7.0375
				],
				[
					0.1625,
					0.305,
					-7.0375
				],
				[
					0.1625,
					0.305,
					-3.231
				],
				[
					0.1625,
					0.305,
					-2.321
				],
				[
					0.1625,
					0.305,
					-2.24
				],
				[
					1.0875,
					0.305,
					-2.24
				],
				[
					1.0875,
					0.305,
					-0.1375
				],
				[
					3.6625,
					0.305,
					-0.1375
				],
				[
					3.6625,
					0.305,
					-7.0375
				]
			]
		}
	},
	{
		name: "Utility",
		uuid: "64bcd922-87ec-55c7-aafd-856ef4ac8878",
		pos: [
			0.5775,
			0.305,
			-1.1413
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			2.0075,
			2.4384,
			0.83
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#c44d58",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "Utility"
		}
	},
	{
		name: "Hallway",
		uuid: "a1aba15f-fabf-5465-af65-87b8c9488e9e",
		pos: [
			-1,
			0.305,
			-1.7163
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			2.05,
			2.4384,
			3.1575
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#4ecdc4",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "Hallway",
			polygon: [
				[
					-1.475,
					0.305,
					-0.1375
				],
				[
					-0.1625,
					0.305,
					-0.1375
				],
				[
					-0.1625,
					0.305,
					-0.3925
				],
				[
					0.025,
					0.305,
					-0.3925
				],
				[
					0.025,
					0.305,
					-1.8925
				],
				[
					-0.1625,
					0.305,
					-1.8925
				],
				[
					-0.1625,
					0.305,
					-2.321
				],
				[
					0.025,
					0.305,
					-2.321
				],
				[
					0.025,
					0.305,
					-3.295
				],
				[
					-0.1641,
					0.305,
					-3.295
				],
				[
					-2.025,
					0.305,
					-3.295
				],
				[
					-2.025,
					0.305,
					-2.24
				],
				[
					-1.475,
					0.305,
					-2.24
				],
				[
					-1.475,
					0.305,
					-0.1375
				]
			]
		}
	},
	{
		name: "Bathroom",
		uuid: "37405297-69c2-51be-a896-c2861d717b57",
		pos: [
			-2.6162,
			0.305,
			-1.1413
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			2.0925,
			2.4384,
			2.0075
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#fe4365",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "Bathroom",
			polygon: [
				[
					-3.6625,
					0.305,
					-2.145
				],
				[
					-3.6625,
					0.305,
					-0.44
				],
				[
					-2.965,
					0.305,
					-0.44
				],
				[
					-2.965,
					0.305,
					-0.1375
				],
				[
					-1.57,
					0.305,
					-0.1375
				],
				[
					-1.57,
					0.305,
					-2.145
				],
				[
					-2.0725,
					0.305,
					-2.145
				],
				[
					-3.6625,
					0.305,
					-2.145
				]
			]
		}
	},
	{
		name: "Storage",
		uuid: "b6d0d38a-2254-5b3a-8fa6-49c8cd8036e3",
		pos: [
			-2.8912,
			0.305,
			-2.7675
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			1.055,
			2.4384,
			1.5425
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#556270",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "Storage"
		}
	},
	{
		name: "module",
		uuid: "2acf858b-b0cb-5ce9-9be5-921fdddf53d8",
		pos: [
			-1.9125,
			1.5175,
			-3.5875
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			3.775,
			3.035,
			7.175
		],
		anchor: [
			0.5,
			0.5,
			0.5
		],
		color: "#cccccc",
		alpha: 1,
		rg: true,
		type: "Module",
		children: [
			{
				name: "wall",
				uuid: "b9247e7e-0d05-59cd-b4cf-00b97bb1a6fd",
				pos: [
					0,
					0.0725,
					-3.5188
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.5,
					2.72,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "window",
						uuid: "b1b3e459-7730-5204-9248-2e60465901c8",
						pos: [
							0,
							0.315,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.6,
							0.8,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#4b5e82",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "WNF|01|UK-WNF0002",
						type: "Window"
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "a28e4042-390d-57a5-8c65-2d7f48037608",
				pos: [
					-1.8188,
					0.0725,
					-0.0687
				],
				rot: [
					0,
					-90,
					0
				],
				size: [
					7.0375,
					2.72,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "707c7dd2-1600-546c-b92a-468f9fffd8f3",
				pos: [
					-0.0688,
					0.0725,
					3.5188
				],
				rot: [
					0,
					-180,
					0
				],
				size: [
					3.6375,
					2.72,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "f86d228d-c1df-5733-837f-27bad945e1a8",
						pos: [
							-1.0538,
							-0.2225,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.01,
							2.09,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|01|UK-DIS0001",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: true
						}
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "afd0b1b1-4b61-5e55-bce3-819c157db24b",
				pos: [
					1.8188,
					0.0725,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					7.175,
					2.72,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "opening",
						uuid: "09250870-5608-538a-ae7f-63cf2c1e0e9e",
						pos: [
							-2.445,
							-0.235,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.5,
							2.1,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#cccccc",
						alpha: 0.5,
						rg: true,
						children: [
						],
						type: "Opening"
					},
					{
						name: "opening",
						uuid: "a6e787a1-cb4f-5df0-82ae-a0d89a6f27f2",
						pos: [
							-0.8115,
							-0.235,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							0.91,
							2.1,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#cccccc",
						alpha: 0.5,
						rg: true,
						children: [
						],
						type: "Opening"
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "floor",
				uuid: "990cbe29-7e42-5b96-b8b9-cb68ce69300b",
				pos: [
					0,
					-1.37,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					6.9,
					0.295,
					3.5
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "FPA|02|",
				type: "Floor"
			},
			{
				name: "wall",
				uuid: "a608532e-3070-58e0-95b8-40c37b07d1c8",
				pos: [
					0,
					0.07,
					0.245
				],
				rot: [
					0,
					-180,
					0
				],
				size: [
					3.55,
					2.585,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "764e51eb-a5ef-5b0f-8d0f-ff721e17c09e",
						pos: [
							-1.225,
							-0.22,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							0.91,
							2.09,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|02|UK-DIS0002",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: false
						}
					},
					{
						name: "door",
						uuid: "b178bdf0-163f-582f-8b82-37c091f3b2cd",
						pos: [
							0.7,
							-0.22,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							0.91,
							2.09,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|02|UK-DIS0002",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: false
						}
					}
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "6528c571-078d-5914-8383-e1b3eec1c352",
				pos: [
					-0.6687,
					0.07,
					1.395
				],
				rot: [
					0,
					-180,
					0
				],
				size: [
					2.2125,
					2.585,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "aaa2f8d4-08b2-53cf-8d36-28f371c93321",
				pos: [
					0.39,
					0.07,
					2.4588
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					2.0325,
					2.585,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "9976bbba-4160-5d2e-9d23-3ca5b1e38eeb",
						pos: [
							0.5033,
							-0.22,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							0.91,
							2.09,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|02|UK-DIS0002",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: false
						}
					}
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "e2e23ee0-6cfb-5a48-8dfd-d1d3d3389253",
				pos: [
					-1.1,
					0.07,
					3.3112
				],
				rot: [
					0,
					-90,
					0
				],
				size: [
					0.3275,
					2.585,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "1980c253-027e-5f2d-b1ac-14080a364d9d",
				pos: [
					-1.4612,
					0.07,
					3.195
				],
				rot: [
					0,
					-180,
					0
				],
				size: [
					0.6275,
					2.585,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "5734cac5-c2c7-502b-a772-a63f1098a958",
				pos: [
					-0.16,
					0.07,
					0.82
				],
				rot: [
					0,
					-90,
					0
				],
				size: [
					1.055,
					2.585,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "ceiling",
				uuid: "ca0b1d63-847b-5332-ae4b-75a4b9f68bf9",
				pos: [
					0,
					1.44,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					6.9,
					0.155,
					3.5
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5ea0bb",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "CPA|05|",
				type: "Ceiling"
			}
		]
	},
	{
		name: "module",
		uuid: "b66f478a-7267-5664-90f4-826d6518e100",
		pos: [
			1.9125,
			1.5175,
			-3.5875
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			3.775,
			3.035,
			7.175
		],
		anchor: [
			0.5,
			0.5,
			0.5
		],
		color: "#cccccc",
		alpha: 1,
		rg: true,
		type: "Module",
		children: [
			{
				name: "wall",
				uuid: "c5df524d-87ea-5c25-830a-f3dc476a70c1",
				pos: [
					0,
					0.0725,
					-3.5188
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.5,
					2.72,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "36595ce3-f984-5d9d-b359-8fdb8d1ac4e9",
						pos: [
							0,
							-0.2225,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.738,
							2.09,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DCD|01|UK-DCD0001",
						type: "Door",
						data: {
							doorType: "Double",
							isEntrance: false
						}
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "b2c47e87-ff0a-5429-9a52-d715a38b5807",
				pos: [
					-1.8187,
					0.0725,
					-0.0687
				],
				rot: [
					0,
					-90,
					0
				],
				size: [
					7.0375,
					2.72,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "b1571035-2b29-549e-b154-48fd356e1649",
						pos: [
							2.5127,
							-0.0925,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.498,
							2.35,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DID|02|UK-DID0002",
						type: "Door",
						data: {
							doorType: "Double",
							isEntrance: false
						}
					},
					{
						name: "door",
						uuid: "cc8f51f2-686e-5383-9806-390c666842a6",
						pos: [
							0.8802,
							-0.2225,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							0.91,
							2.09,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|02|UK-DIS0002",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: false
						}
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "5eefca54-6921-5371-9543-15f1482deec2",
				pos: [
					-0.0688,
					0.0725,
					3.5188
				],
				rot: [
					0,
					-180,
					0
				],
				size: [
					3.6375,
					2.72,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "82200275-25e5-51a4-8f93-20c44c9fa1d8",
				pos: [
					1.8187,
					0.0725,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					7.175,
					2.72,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "floor",
				uuid: "2690565e-2960-528e-9927-dd88dba148cb",
				pos: [
					0,
					-1.37,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					6.9,
					0.295,
					3.5
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "FPA|02|",
				type: "Floor"
			},
			{
				name: "wall",
				uuid: "45d981f8-532a-54a8-b0cc-fc5d4e276910",
				pos: [
					-1.2875,
					0.07,
					1.395
				],
				rot: [
					0,
					-180,
					0
				],
				size: [
					0.925,
					2.585,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "c94e1ffa-a976-5001-accd-cd676293f6cb",
				pos: [
					-0.8725,
					0.07,
					2.4463
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					2.0075,
					2.585,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "ceiling",
				uuid: "74454d57-d966-5afc-a53e-8709eae7cb00",
				pos: [
					0,
					1.44,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					6.9,
					0.155,
					3.5
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5ea0bb",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "CPA|05|",
				type: "Ceiling"
			}
		]
	}
];
var data = {
	level: -1,
	levelId: "",
	occupants: 2,
	bedrooms: 1,
	habitableRooms: 2,
	nia: 50.3315,
	muscleID: "",
	category: "1B2P"
};
var UK02_1B2P_01 = {
	name: name,
	uuid: uuid,
	pos: pos,
	rot: rot,
	size: size,
	anchor: anchor,
	color: color,
	alpha: alpha,
	rg: rg,
	type: type,
	children: children,
	data: data
};

export { alpha, anchor, children, color, data, UK02_1B2P_01 as default, name, pos, rg, rot, size, type, uuid };
//# sourceMappingURL=UNT-01-1b2p-01s.json.js.map
